import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
  import { useTask } from '@/ui/concerns';
  import { Box } from '@/ui/components/Box';
  import { Loader } from '@/ui/components/Loader';
  import { Button } from '@/ui/components/Button';
  import { PageTitle } from '@/ui/components/PageTitle';
  import Level from '@/ui/components/common/Level.vue';
  import CourseReportInfo from '@/ui/components/trainings/report/CourseReportInfo.vue';
  import CourseOutline from '@/ui/components/trainings/report/CourseOutline.vue';
  import { getCourseReport } from '@/services/api/resources/trainings/course-report/actions';
  import type { CourseReportDetail } from '@/entities/trainings/course-report/model';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseReportPage',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const report = ref<CourseReportDetail | null>(null);

  const getReport = useTask(
    () => getCourseReport(props.id),
    result => {
      report.value = result;
    },
  );

  onMounted(() => {
    getReport.run();
  });

return { __sfc: true,props, report, getReport, Box, Loader, Button, PageTitle, Level, CourseReportInfo, CourseOutline }
}

})